var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "over_layout" },
    [
      _c("section", { staticClass: "upgrade" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.$store.commit("paymentModal", true)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$store.getters.t("create_resume")))]
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "blog" }, [
        _c("div", { staticClass: "wrapper" }, [
          _c("div", { staticClass: "pages_header" }, [
            _c("div", { staticClass: "lines" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(
                    _vm.category.name
                      ? _vm.category.name
                      : "CVweb " + _vm.$store.getters.t("blog")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.category.short_content) }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "blog_block" }, [
            _c(
              "div",
              { staticClass: "left_content" },
              [
                _c("bred-crumbs", {
                  attrs: { navigation: _vm.navigateUrls(_vm.category.name) }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "title_part" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$store.getters.t("our_advices")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "all_post_blog" },
                  _vm._l(_vm.posts.data, function(post) {
                    return _c(
                      "div",
                      { key: post.id, staticClass: "post_type" },
                      [
                        _c(
                          "div",
                          { staticClass: "text_b" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "link",
                                attrs: {
                                  to: {
                                    name: "blog.category.post",
                                    params: {
                                      lang: _vm.$store.getters.locale,
                                      category: post.category_slug,
                                      post: post.slug
                                    }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(post.name) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(post.short_content)
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "more_a" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "blog.category.post",
                                        params: {
                                          lang: _vm.$store.getters.locale,
                                          category: post.category_slug,
                                          post: post.slug
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$store.getters.t("Read_more")
                                      ) +
                                        "...\n                                    "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "blog.category.post",
                                    params: {
                                      lang: _vm.$store.getters.locale,
                                      category: post.category_slug,
                                      post: post.slug
                                    }
                                  }
                                }
                              },
                              [_c("img", { attrs: { src: post.photo } })]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right_sidebar" }, [
              _c("div", { staticClass: "fix_bar" }, [
                _c("div", { staticClass: "category_title" }, [
                  _vm._v(_vm._s(_vm.$store.getters.t("category")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "category_list" }, [
                  _c(
                    "ul",
                    [
                      _vm._l(this.categories, function(category) {
                        return _c(
                          "li",
                          {
                            key: category.id,
                            attrs: { title: category.seo_title }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  "active-class": "active",
                                  to: {
                                    name: "blog.category",
                                    params: {
                                      lang: _vm.$store.getters.locale,
                                      category: category.slug
                                    }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(category.name) +
                                    "\n                                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._m(1)
                    ],
                    2
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.posts.last_page !== 1
        ? [
            this.$route.params.category
              ? _c("pagination", {
                  attrs: { data: _vm.posts },
                  on: { "pagination-change-page": _vm.getBlogCategory }
                })
              : _c("pagination", {
                  attrs: { data: _vm.posts },
                  on: { "pagination-change-page": _vm.getBlogList }
                })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search_box" }, [
      _c("form", [
        _c("input", {
          staticClass: "search_input",
          attrs: { placeholder: "Search", required: "", type: "text" }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "submit_search",
          attrs: { type: "submit", value: " " }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://ru.jobsora.com/", target: "_blank" } },
        [_vm._v("Найти работу уже сейчас")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4e827ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4e827ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/blog/Blog.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c4e827ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/blog/Blog.vue
// module chunks = 0